import * as Styled from './Text.styled';
import type { TextProps } from './Text.types';

export const Text = (props: TextProps) => {
  const {
    as = 'p',
    children,
    size = 'l',
    weight = 'regular',
    color,
    inline,
    align,
    className,
    ...rest
  } = props;
  return (
    <Styled.Text
      as={as}
      color={color}
      size={size}
      weight={weight}
      align={align}
      className={className}
      inline={inline}
      {...rest}
    >
      {children}
    </Styled.Text>
  );
};

export default Text;
